import Seo from "../components/Seo";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, resolveImg } from "../lib/api";
import { ChevronLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`).then(({ data }) => { setPost(data); })
      .catch(() => navigate("/blog"));
  }, [slug, navigate]);
  if (!post) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-charcoal/50">Зареждане...</div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="blog-post">
      <Seo
        title={post.seo_title || post.title}
        description={post.seo_description || post.excerpt || (post.content || "").replace(/<[^>]+>/g, "").slice(0, 160)}
        path={`/blog/${post.slug}`}
        image={post.cover_image ? resolveImg(post.cover_image) : undefined}
        type="article"
      />
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-charcoal/60 hover:text-gold mb-6"><ChevronLeft size={16} /> Към блога</Link>
      <h1 className="font-serif text-3xl md:text-5xl text-navy leading-tight">{post.title}</h1>
      <div className="gold-line my-6" />
      {post.cover_image && <img src={resolveImg(post.cover_image)} alt={post.title} className="w-full h-[320px] object-cover mb-8" />}
      <div className="rich-content text-charcoal/80 leading-relaxed text-lg" dangerouslySetInnerHTML={{ __html: post.content }} />
    </article>
  );
}
